module.exports = __webpack_public_path__ + "5dfd53921c0a737aae702b586cd892aa.svg";